import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ORSMSettingsWorkplaceSelection from './ORSMSettingsWorkplaceSelection';
import { Workplace } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	workplaces: Workplace[];
	onSelect: (workplace: Workplace) => void;
}

const ORSMSettingsWorkplaceSelectionModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.ORSMSettingsWorkplaceSelection.modalTitle'>
			<ORSMSettingsWorkplaceSelection
				onSelect={props.onSelect}
				workplaces={props.workplaces}
			/>
		</BaseModal>
	);
};

export default ORSMSettingsWorkplaceSelectionModal;
